import Image from '@atoms/Image/Image';
import LinkCard from '@atoms/LinkCard/LinkCard';
import { IImageWithLink } from '@models/IImageWithLink';
import updateDataLayer from '@utils/helpers/gtm';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import classNames from 'classnames';

interface Props extends IImageWithLink {
  readonly pageObject?: {
    readonly pageType: string;
  };
  readonly index: number;
}

const HighlightCard = ({
  media,
  pageObject,
  simpleLink,
  subTitle,
  title,
  index,
}: Props) => {
  const isSmalldesktop = useMediaQuery(1440);
  const isLargeDesktop = useMediaQuery(1900);
  const isSmallToLargeDesktop = isLargeDesktop && !isSmalldesktop;
  const textBodyStyles = isSmallToLargeDesktop ? 'body-three' : 'body-one';

  return (
    <LinkCard
      className="p-2.5 lg:pr-6"
      onClick={() => {
        if (pageObject?.pageType === 'HomepagePageViewModel') {
          updateDataLayer({
            event: 'selectContent',
            content_type: 'highlight_card',
            link_text: simpleLink?.url,
          });
        }
      }}
      link={simpleLink}
      useSmallCard={isSmallToLargeDesktop}
      dataTestId={`CT-04A1-Highlight-Card-${index}`}
    >
      <div className="flex h-full w-full flex-row items-center gap-3 md:gap-4">
        {media && (
          <div className="h-full w-1/3 shrink-0 lg:w-1/2 xl:w-5/12">
            <Image
              image={media}
              imageClasses="h-full object-contain"
              sizes="300px"
              dataTestId={`CT-04A1-Highlight-Card-Image-${index}`}
            />
          </div>
        )}

        {(title || subTitle) && (
          <div className="flex flex-col">
            {title && (
              <p
                className={classNames(
                  'font-light text-grey-450 dark:text-yellow',
                  textBodyStyles
                )}
                data-testid={`CT-04A1-Highlight-Card-Title-${index}`}
              >
                {title}
              </p>
            )}
            {subTitle && (
              <p
                className={classNames(
                  'font-light dark:text-white',
                  textBodyStyles
                )}
                data-testid={`CT-04A1-Highlight-Card-Subtitle-${index}`}
              >
                {subTitle}
              </p>
            )}
          </div>
        )}
      </div>
    </LinkCard>
  );
};

export default HighlightCard;
